import * as Sentry from '@sentry/react';
import { t } from 'i18next';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import {
  RegisterPaymentRequest,
  RegisterPaymentResponse,
} from '@cashier/cashier-api-model';

import { PaymentActionMapper } from '../utils/mapper';
import {
  registerPaymentFailure,
  registerPaymentStart,
  registerPaymentSuccess,
} from './paymentRegistration.slice';

export const paymentRegistrationEpic = (action$, state$, { Api }) =>
  action$.pipe(
    ofType(registerPaymentStart.type),
    switchMap((action: { payload: RegisterPaymentRequest }) =>
      Api.registerPayment(action.payload).pipe(
        map((data: RegisterPaymentResponse) => {
          if (data.resultAction === null) {
            Sentry.captureException(
              new Error(
                '###Successful status returned, but resultAction is null. Status###:',
              ),
              {
                extra: {
                  status: data.status,
                },
              },
            );

            return registerPaymentFailure({
              message: t('failureRegistrationChannel.message'),
              attributeErrorBag: null,
              errorDetails: null,
              transactionId: null,
              context: null,
            });
          }

          return registerPaymentSuccess(
            PaymentActionMapper.toResultAction(data.resultAction),
          );
        }),
        catchError((err) =>
          of(
            registerPaymentFailure(
              PaymentActionMapper.toPaymentActionError(err),
            ),
          ),
        ),
      ),
    ),
  );

export const registerPayment = (data: RegisterPaymentRequest) => ({
  type: registerPaymentStart.type,
  payload: data,
});
